export enum QuestionAcceptedState {
  UserSubmitted = 0,
  Online = 1,
  Private = 2,
  DeleteIntention = 3,
  WillDeleteSoon = 4,
}

export enum EntityChangeOperation {
  Create = "create",
  Update = "update",
  Delete = "delete",
}

export enum BasicOptionCheckState {
  Default = "default",
  Correct = "correct",
  Wrong = "wrong",
}

export enum ChoiceOptionState {
  Default = "default",
  CorrectPending = "correctPending",
  CorrectDone = "correctDone",
  ShouldHaveBeenSelected = "shouldHaveBeenSelected",
  Wrong = "wrong",
}

export enum FunnelType {
  Standard = "default",
  Succession = "succession",
}

export enum MannerType {
  HearWord = "hearWord",
  MannerPile = "hearWordSequence",
  HearAnything = "hearAnything",
  AutoExpire = "expire",
}

export enum MannerTypeLabels {
  hearWord = "Spracheingabe enthält Wort",
  hearWordSequence = "Spracheingabe enthält Wortsequenz",
  hearAnything = "Spracheingabe enthält irgendetwas",
  expire = "Zeit läuft ab",
}

export enum ConductType {
  SetQuestionCorrect = "setQuestionCorrect",
  SetQuestionWrong = "setQuestionWrong",
  PlayMedia = "playMedia",
  SetAnswerMark = "setAnswerMark",
}

export enum ConductTypeLabels {
  setQuestionCorrect = "Frage als korrekt werten",
  setQuestionWrong = "Frage als falsch werten",
  playMedia = "Audio/Video abspielen",
  setAnswerMark = "Antwortmarke setzen",
}

export enum QuestionPassStateId {
  New = "new",
  Wrong = "wrong",
  PartialCorrect = "partialcorrect",
  Blocked = "blocked",
  Skipped = "skipped",
  Passed = "passed",
  CorrectAfterWrong = "correctafterwrong",
  Passed2 = "passed2",
  Passed3 = "passed3",
  Phase1 = "phase1",
  Phase2 = "phase2",
  Phase3 = "phase3",
  Phase4 = "phase4",
}

export enum AudioVisualization {
  SpeakerIcon = "speaker",
}

export enum LevelAccess {
  Free = "free",
  Premium = "premium",
}

export enum QuestionAnswerState {
  Preload = "preload",
  Answering = "answering",
  Feedback = "feedback",
  Continue = "continue",
  History = "history",
  Editing = "editing",
}

export enum AppearState {
  Appearing = "appearing",
  Visible = "visible",
  Disappearing = "disappearing",
  Hidden = "hidden",
}

export enum QuestionTypeName {
  MultipleChoice = "MultipleChoice",
  CorrectWrong = "CorrectWrong",
  KnowAWord = "KnowAWord",
  Associate = "Associate",
  MemorizePoints = "MemorizePoints",
  ThinkAndReveal = "ThinkAndReveal",
  Vocabulary = "Vocabulary",
  Read = "Read",
  Talk = "Talk",
  OrderedChoice = "OrderedChoice",
  Intro = "Intro",
  CycleEnd = "CycleEnd",
  Sortable = "Sortable",
  MultiSelect = "MultiSelect",
}

export enum MediaLabel {
  None = "",
  local = "local",
  questionpart = "questionpart",
  questionVideo = "questionVideo",
  questionAudio = "questionAudio",
  optionSelected = "optionSelected",
  optionHover = "optionHover",
  questionwrong = "questionwrong",
  questioncorrect = "questioncorrect",
  questioncomplete = "questioncomplete",
  questionCompletlyWrong = "questionCompletlyWrong",
  questionPartiallyWrong = "questionPartiallyWrong",
  questionClose = "questionClose",
  correctStep = "correctStep",
  correctComplete = "correctComplete",
  wrongStep = "wrongStep",
  wrongComplete = "wrongComplete",
  cycleBegin = "cycleBegin",
  cycleEnd = "cycleEnd",
  associationWrong = "associationWrong",
  associationCorrect = "associationCorrect",
  associationComplete = "associationComplete",
  enforcementTip = "enforcementTip",
  enforcementPush = "enforcementPush",
  executeManner = "executeManner",
  backgroundRun = "backgroundRun",
  backgroundComplete = "backgroundComplete",
  backgroundCorrect = "backgroundCorrect",
  backgroundWrong = "backgroundWrong",
  taskActive = "taskActive",
  taskWrong = "taskWrong",
  taskCorrect = "taskCorrect",
  taskComplete = "taskComplete",
  taskWrongTry = "taskWrongTry",
  stepWrongTry = "stepWrongTry",
  stepWrong = "stepWrong",
  stepCorrect = "stepCorrect",
  stepComplete = "stepComplete",
}

export enum QuestionScoreFactor {
  NotYetShown = 60,
  LeastOftenShown = 80,
  BadResults = 30,
  DidacticalRepetition = 30,
  BestRated = 80,
  AdaptiveDifficulty = 60,
  ProgressiveDifficulty = 30,
  AlterQuestionType = 30,
  AlterSubtopic = 30,
  AlterLayout = 60,
  SkipRate = 30,
  ExitRate = 30,
  IsNativeInTopic = 30,
  TouchFriendlyQuestionType = 150,
  LevelSuccession = 100,
}

export enum LearnwareInstance {
  AbfragerDE = "abfrager.de",
  AbfragerAT = "abfrager.at",
  AbfragerCH = "abfrager.ch",
  AbfragerES = "abfrager.es",
}

export enum AudioRecorderState {
  NoUsage = "nousage",
  GetReady = "getready",
  Recording = "recording",
  Finished = "finished",
}

export enum SoundCategory {
  NotClassified = "",
  AudioRecording = "recording",
  SoundEffect = "soundeffect",
}

export enum ImageCategory {
  NotClassified = "",
  Clipart = "clipart",
  Photo = "photo",
  Illustration = "illustration",
}

export enum MediaSourceDatabase {
  Unknown = "",
  Pixabay = "pixabay",
  OpenClipart = "openclipart",
  FreeSound = "freesound",
  Abfrager = "abfrager",
  Upload = "upload",
  None = "none",
}

export enum EditActorLayerTabs {
  Aspects = "aspects",
  Structure = "structure",
  Properties = "properties",
}

export enum TraitScaleType {
  Ratio = "ratio",
  Height = "height",
  Width = "width",
}

export enum LoadStatus {
  // Loading = 'loading',
  Loading = "load",
  Ready = "ready",
}

export enum PlayStatus {
  // Loading = 'loading',
  Pending = "pending",
  Go = "go",
  Playing = "playing",
  Paused = "paused",
  Ended = "ended",
  Aborted = "aborted",
  Error = "error",
}

export enum ChannelName {
  Voice = "voice",
  Sound = "sound",
  Background = "background",
}

export enum SetAspectValueStrategy {
  ActiveButOnlyLocal = "current",
}

export enum SSMLLanguage {
  DE = "de-de",
  EN_US = "en-us",
  EN_GB = "en-gb",
  FR = "fr-fr",
}

export enum Scene {
  Loading = "loading",
  Empty = "empty",
  History = "showHistory",
  CycleEnd = "cycleEnd",
  ShowQuestion = "showQuestion",
  NoMoreQuestions = "noMoreQuestions",
  PreviewQuestion = "previewQuestion",
}

export enum SlotCategory {
  Audio = "audio",
  Speak = "speak",
  Hear = "hear",
  Question = "question",
  Other = "other",
}

export enum IsoLanguageCode {
  de_DE = "de_DE",
  // fr_FR = 'fr_FR',
  // en_GB = 'en_GB',
  de_AT = "de_AT",
  de_CH = "de_CH",
  de_ES = "es_ES",
  // en_US = 'en_US'
}

export enum CommentType {
  Comment = "comment",
  CommentCorrect = "commentCorrect",
  CommentWrong = "commentWrong",
}

export enum ScaleType {
  None = "none",
  Width = "width",
  Height = "height",
  Ratio = "ratio",
}

export enum CorrectWrongButton {
  CorrectWrong = 0,
  YesNo = 1,
  Custom = 2,
}

export enum CorrectWrongValue {
  StatementIsCorrect = 1,
  StatementIsWrong = 0,
}

export enum MemoryType {
  Any = "",
  PlayedMedia = "mediaplay",
}

export enum TrackIdent {
  ShowQuestion = "show",
  ContinueImmediatelyAfterAnswer = "immediate",
  AnswerQuestion = "answer",
  RateQuestion = "rateQ",
  RateTopic = "rateT",
  BlockQuestion = "block",
  SkipQuestion = "skip",
}

export enum HideStrategy {
  ShowAll = "",
  HideCorrectsOfPreviousSteps = "step1",
}

export interface MicroUser {
  id: number
  encrypted: string
  email: string
  prename: string
  guest: number
}

export enum KnowledgeLevel {
  Intro = 1,
  Lernen = 4,
  Erkennen = 7,
  Auswählen = 10,
  Schreiben = 13,
  Abfragen = 15,
  Pruefung = 18,
  Exit = 20,
}

export function enumKeys<O extends object, K extends keyof O = keyof O>(obj: O): K[] {
  return Object.keys(obj).filter((k) => Number.isNaN(+k)) as K[]
}

export enum InputMaskType {
  Auto = "",
  TimeX_XX = "timeX:XX",
  TimeXX_XX = "timeXX:XX",
  Integer = "integer",
  Decimal = "decimal",
  Decimal1x1 = "decimal1x1",
  Decimal1x2 = "decimal1x2",
  Addition3x1E2 = "addition3x1E2",
  Addition3x1E1 = "addition3x1E1",
  Addition3P2P1 = "addition3P2P1",

  EuroCent = "euroCent",
  Einheit = "einheit",
  Uhrzeit = "uhrzeit",
  /*
  Euro = 'euro',
  Cent = 'cent',
  Milliliter = 'ml',
  Liter = 'l',
  Kilogramm = 'kg',
  Gramm = 'g',
*/
  NumberPrefixSuffix = "numberPrefixSuffix",

  //PlusSymbolInteger = '+Integer',
  //MinusSymbolInteger = '-Integer',
  // AllowNegativeInteger = '+-Integer',
}

export const CONST_EINHEITEN = ["ct", "€", "ml", "l", "kg", "g", "min", "s", "h"]

export enum MeasureType {
  BoundingClientRect = "rect", // Includes Transform (scale, perspective, translateX, ...)
  OffsetToPage = "offset", // does not include transform
}
